(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["build-your-bundle"] && !Shopify.designMode) return;
  try {
    
  (function() {
    document.querySelectorAll('.bundle-builder').forEach(function(container) {
      var config = {
        minAmount: parseInt(container.dataset.minAmount, 10) || 120,
        discountPercent: parseInt(container.dataset.discountPercent, 10) || 15,
        moneyFormat: container.dataset.moneyFormat || '$' + String.fromCharCode(123, 123) + 'amount' + String.fromCharCode(125, 125),
        addMoreTemplate: container.dataset.addMoreTemplate || '',
        unlockedText: container.dataset.unlockedText || '',
        addingText: container.dataset.addingText || 'Adding...',
        submitText: container.dataset.submitText || 'Add bundle to cart',
        errorText: container.dataset.errorText || 'Something went wrong.'
      };

      var bundleItems = new Map();

      var bar = container.querySelector('.bundle-bar');
      var emptyState = bar.querySelector('.bundle-bar__empty-state');
      var filledState = bar.querySelector('.bundle-bar__filled-state');
      var progressTrackFill = bar.querySelector('.bundle-bar__progress-fill');
      var emptyProgress = emptyState.querySelector('.bundle-bar__progress');
      var barThumbs = bar.querySelector('.bundle-bar__thumbs');
      var filledProgress = filledState.querySelector('.bundle-bar__progress');
      var barPriceOriginal = bar.querySelector('.bundle-bar__price-original');
      var barPrice = bar.querySelector('.bundle-bar__price');
      var barDiscountTag = bar.querySelector('.bundle-bar__discount-tag');
      var barSubmit = bar.querySelector('.bundle-bar__submit');
      var barExpand = bar.querySelector('.bundle-bar__expand');
      var panel = container.querySelector('.bundle-bar__panel');
      var panelItems = panel.querySelector('.bundle-bar__panel-items');
      var panelEmpty = panel.querySelector('.bundle-bar__panel-empty');
      var panelClose = panel.querySelector('.bundle-bar__panel-close');
      var cards = container.querySelectorAll('.bundle-card');

      function formatMoney(cents) {
        if (typeof cents !== 'number' || isNaN(cents)) 
          cents = 0;
        


        cents = Math.round(cents);
        var absVal = Math.abs(cents);
        var w = Math.floor(absVal / 100).toString();
        var d = (absVal % 100).toString().padStart(2, '0');
        var sign = cents < 0
          ? '-'
          : '';
        function sep(s, c) {
          return s.replace(/\B(?=(\d{3})+(?!\d))/g, c);
        }
        var B = String.fromCharCode(123, 123);
        var E = String.fromCharCode(125, 125);
        var formatted = config
          .moneyFormat
          .replace(B + 'amount_with_comma_separator' + E, sep(w, '.') + ',' + d)
          .replace(B + 'amount_no_decimals_with_comma_separator' + E, sep(w, '.'))
          .replace(B + 'amount_no_decimals' + E, sep(w, ','))
          .replace(B + 'amount' + E, sep(w, ',') + '.' + d);
        return sign + formatted;
      }

      function generateUUID() {
        if (typeof crypto !== 'undefined' && crypto.randomUUID) return crypto.randomUUID();
        


        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
          var r = (Math.random() * 16) | 0;
          return(
            c === 'x'
              ? r
              : (r & 0x3) | 0x8
          ).toString(16);
        });
      }

      function esc(s) {
        var e = document.createElement('span');
        e.textContent = s;
        return e.innerHTML;
      }

      function getTotalQty() {
        var t = 0;
        bundleItems.forEach(function(i) {
          t += i.quantity;
        });
        return t;
      }
      function getTotalPrice() {
        var t = 0;
        bundleItems.forEach(function(i) {
          t += i.price * i.quantity;
        });
        return t;
      }
      function isUnlocked() {
        return getTotalPrice() >= config.minAmount * 100;
      }

      function getSelectedVariantId(card) {
        var activeBtn = card.querySelector('.bundle-card__variant-btn.is-active');
        if (activeBtn) return parseInt(activeBtn.dataset.variantId, 10);
        


        var variants = [];
        try {
          variants = JSON.parse(card.dataset.variants || '[]');
        } catch (e) {}return variants.length > 0
          ? variants[0].id
          : null;
      }

      function getVariantData(card, variantId) {
        var variants = [];
        try {
          variants = JSON.parse(card.dataset.variants || '[]');
        } catch (e) {}for (var i = 0; i < variants.length; i++) {
          if (variants[i].id === variantId) return variants[i];
          


        }
        return variants[0] || null;
      }

      function addItem(variantId, productId, productTitle, variantTitle, price, imageUrl, unitLabel) {
        var key = String(variantId);
        if (bundleItems.has(key)) {
          bundleItems.get(key).quantity += 1;
        } else {
          bundleItems.set(key, {
            variantId: variantId,
            productId: productId,
            productTitle: productTitle,
            variantTitle: variantTitle,
            price: price,
            quantity: 1,
            imageUrl: imageUrl,
            unitLabel: unitLabel
          });
        }
        updateUI();
      }

      function removeItem(variantId) {
        bundleItems.delete(String(variantId));
        updateUI();
      }

      function changeQty(variantId, delta) {
        var key = String(variantId);
        var item = bundleItems.get(key);
        if (! item) return;
        


        item.quantity += delta;
        if (item.quantity<= 0) bundleItems.delete(key);
        updateUI();
      }

      function updateUI() {
        var totalQty = getTotalQty();
        var totalPrice = getTotalPrice();
        var minAmountCents = config.minAmount * 100;
        var unlocked = isUnlocked();
        var discountAmount = unlocked ? Math.round(totalPrice * config.discountPercent / 100) : 0;
        var finalPrice = totalPrice - discountAmount;
        var remainingCents = minAmountCents - totalPrice;

        var progressPct = Math.min((totalPrice / minAmountCents) * 100, 100);
        var progressMsg = '';
        var isComplete = false;

        if (unlocked) {
          progressMsg = config.unlockedText;
          isComplete = true;
        } else if (remainingCents> 0) {
          progressMsg = config.addMoreTemplate.replace('__AMOUNT__', formatMoney(remainingCents));
        }

        if (totalQty === 0) {
          emptyState.hidden = false;
          filledState.hidden = true;
          barExpand.hidden = true;
          panel.hidden = true;
          barExpand.setAttribute('aria-expanded', 'false');
          emptyProgress.textContent = progressMsg;
          emptyProgress.classList.remove('is-complete');
          progressTrackFill.style.width = '0%';
        } else {
          emptyState.hidden = true;
          filledState.hidden = false;
          barExpand.hidden = false;
          filledProgress.textContent = progressMsg;
          filledProgress.classList.toggle('is-complete', isComplete);
          progressTrackFill.style.width = progressPct + '%';
        }

        if (totalQty > 0 && unlocked) {
          barPriceOriginal.textContent = formatMoney(totalPrice);
          barPrice.textContent = formatMoney(finalPrice);
          barDiscountTag.hidden = false;
        } else if (totalQty > 0) {
          barPriceOriginal.textContent = '';
          barPrice.textContent = formatMoney(totalPrice);
          barDiscountTag.hidden = true;
        } else {
          barPriceOriginal.textContent = '';
          barPrice.textContent = '';
          barDiscountTag.hidden = true;
        } barSubmit.disabled = !unlocked;

        barThumbs.innerHTML = '';
        var seen = {};
        bundleItems.forEach(function(item) {
          if (seen[item.productId]) {
            var existingBadge = seen[item.productId].querySelector('.bundle-bar__thumb-qty');
            var prev = parseInt(existingBadge.textContent, 10);
            existingBadge.textContent = String(prev + item.quantity);
            return;
          }
          var thumb = document.createElement('div');
          thumb.className = 'bundle-bar__thumb';
          thumb.innerHTML = '<img src="' + esc(item.imageUrl) + '" alt="" /><span class="bundle-bar__thumb-qty">' + item.quantity + '</span>';
          barThumbs.appendChild(thumb);
          seen[item.productId] = thumb;
        });

        panelItems.innerHTML = '';
        bundleItems.forEach(function(item) {
          var vLabel = item.variantTitle && item.variantTitle !== 'Default Title'
            ? '<div class="bundle-bar__panel-item-variant">' + esc(item.variantTitle) + '</div>'
            : '';
          var li = document.createElement('li');
          li.className = 'bundle-bar__panel-item';
          li.innerHTML = '<img class="bundle-bar__panel-item-img" src="' + esc(item.imageUrl) + '" alt="" />' + '<div class="bundle-bar__panel-item-info"><div class="bundle-bar__panel-item-title">' + esc(item.productTitle) + '</div>' + vLabel + '</div>' + '<div class="bundle-bar__panel-item-qty">' + '<button type="button" class="bundle-bar__panel-qty-btn" data-action="decrease" data-vid="' + item.variantId + '">\u2212</button>' + '<span class="bundle-bar__panel-qty-val">' + item.quantity + '</span>' + '<button type="button" class="bundle-bar__panel-qty-btn" data-action="increase" data-vid="' + item.variantId + '">+</button>' + '</div>' + '<span class="bundle-bar__panel-item-price">' + formatMoney(item.price * item.quantity) + '</span>' + '<button type="button" class="bundle-bar__panel-item-remove" data-vid="' + item.variantId + '">\u2715</button>';
          panelItems.appendChild(li);
        });
        panelEmpty.style.display = bundleItems.size === 0
          ? ''
          : 'none';

        updateCards();
      }

      function updateCards() {
        cards.forEach(function(card) {
          var vid = getSelectedVariantId(card);
          var key = String(vid);
          var inBundle = bundleItems.has(key);
          var qty = inBundle
            ? bundleItems.get(key).quantity
            : 0;

          var anyVariantInBundle = false;
          try {
            var variants = JSON.parse(card.dataset.variants || '[]');
            for (var i = 0; i < variants.length; i++) {
              if (bundleItems.has(String(variants[i].id))) {
                anyVariantInBundle = true;
                break;
              }
            }
          } catch (e) {}card.classList.toggle('is-selected', anyVariantInBundle);

          var addBtn = card.querySelector('.bundle-card__add-btn');
          var qtyWrap = card.querySelector('.bundle-card__qty-wrap');
          var qtyVal = card.querySelector('.bundle-card__qty-value');
          var unitLabel = card.dataset.unitLabel || '';

          if (qty > 0) {
            addBtn.style.display = 'none';
            qtyWrap.hidden = false;
            qtyVal.textContent = unitLabel
              ? qty + ' ' + unitLabel
              : String(qty);
          } else {
            addBtn.style.display = '';
            qtyWrap.hidden = true;
          }
        });
      }

      cards.forEach(function(card) {
        var addBtn = card.querySelector('.bundle-card__add-btn');
        var variantBtns = card.querySelectorAll('.bundle-card__variant-btn');
        var priceEl = card.querySelector('.bundle-card__price');

        function syncVariantStyles(card) {
          card.querySelectorAll('.bundle-card__variant-btn').forEach(function(b) {
            if (b.classList.contains('is-active')) {
              b.style.backgroundColor = '#1a1a1a';
              b.style.color = '#ffffff';
              b.style.borderColor = '#1a1a1a';
            } else {
              b.style.backgroundColor = '';
              b.style.color = '';
              b.style.borderColor = '';
            }
          });
        }
        syncVariantStyles(card);

        variantBtns.forEach(function(btn) {
          btn.addEventListener('click', function() {
            if (btn.disabled) return;
            


            card.querySelectorAll('.bundle-card__variant-btn').forEach(function(b) {
              b.classList.remove('is-active');
            });
            btn.classList.add('is-active');
            syncVariantStyles(card);
            priceEl.textContent = formatMoney(parseInt(btn.dataset.price, 10));
            priceEl.dataset.price = btn.dataset.price;
            addBtn.disabled = btn.disabled;
            updateCards();
          });
        });

        addBtn.addEventListener('click', function() {
          var vid = getSelectedVariantId(card);
          var vData = getVariantData(card, vid);
          if (! vid || ! vData) return;
          


          addItem(vid, card.dataset.productId, card.querySelector('.bundle-card__title').textContent.trim(), vData.title, vData.price, card.dataset.productImage || '', card.dataset.unitLabel || '');
        });

        card.querySelector('.bundle-card__qty-wrap').addEventListener('click', function(e) {
          var btn = e.target.closest('[data-action]');
          if (! btn) return;
          


          var vid = getSelectedVariantId(card);
          if (! vid) return;
          


          if (btn.dataset.action === 'increase') {
            var vData = getVariantData(card, vid);
            addItem(vid, card.dataset.productId, card.querySelector('.bundle-card__title').textContent.trim(), vData.title, vData.price, card.dataset.productImage || '', card.dataset.unitLabel || '');
          } else {
            changeQty(vid, -1);
          }
        });
      });

      panelItems.addEventListener('click', function(e) {
        var btn = e.target.closest('button');
        if (! btn || ! btn.dataset.vid) return;
        


        var vid = parseInt(btn.dataset.vid, 10);
        if (btn.classList.contains('bundle-bar__panel-item-remove')) 
          removeItem(vid);
         else if (btn.dataset.action === 'increase') 
          changeQty(vid, 1);
         else if (btn.dataset.action === 'decrease') 
          changeQty(vid, -1);
        


      });

      function togglePanel() {
        var open = ! panel.hidden;
        panel.hidden = open;
        barExpand.setAttribute('aria-expanded', String(! open));
      }

      barExpand.addEventListener('click', togglePanel);
      panelClose.addEventListener('click', function() {
        panel.hidden = true;
        barExpand.setAttribute('aria-expanded', 'false');
      });

      function setLoading(on) {
        barSubmit.disabled = on || ! isUnlocked();
        barSubmit.classList.toggle('is-loading', on);
        barSubmit.textContent = on
          ? config.addingText
          : config.submitText;
      }

      function addBundleToCart() {
        if (! isUnlocked()) return;
        


        var bundleId = generateUUID();
        var items = [];
        bundleItems.forEach(function(item) {
          items.push({
            id: item.variantId,
            quantity: item.quantity,
            properties: {
              _bundle_id: bundleId,
              _bundle_discount: String(config.discountPercent),
              _bundle_min_amount: String(config.minAmount)
            }
          });
        });
        setLoading(true);
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify(
            {items: items}
          )
        })
          .then(function(res) {
            if (! res.ok) return res.json().then(function(err) {
                throw new Error(err.description || err.message || config.errorText);
              });
            


            return res.json();
          })
          .then(function() {
            bundleItems.clear();
            updateUI();
            panel.hidden = true;
            barExpand.setAttribute('aria-expanded', 'false');

            var cartEvent = new Event('cart:update', {bubbles: true});
            cartEvent.detail = {
              resource: {},
              sourceId: '',
              data: {}
            };
            document.dispatchEvent(cartEvent);

            var cartDrawer = document.querySelector('cart-drawer-component');
            if (cartDrawer && typeof cartDrawer.open === 'function') 
              cartDrawer.open();
            


          })
          .catch(function(err) {
            alert(err.message || config.errorText);
          })
          . finally(function() {
            setLoading(false);
          });
      }

      barSubmit.addEventListener('click', addBundleToCart);
      updateUI();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener('DOMContentLoaded', () => {
      const card = document.getElementById(url.hash.slice(1));
      if (card) {
        card.scrollIntoView({behavior: 'instant'});
      }
    }, {once: true});
  }

  } catch(e) { console.error(e); }
})();
})();
